// frontend/src/api/audit.js

async function parseResponse(res) {
  const contentType = res.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");
  const payload = isJson ? await res.json() : await res.text();

  if (!res.ok) {
    const detail = isJson && payload ? payload.detail : null;
    const message =
      (isJson && payload && payload.message) ||
      (typeof detail === "string" && detail) ||
      (detail && typeof detail === "object" && (detail.error || JSON.stringify(detail))) ||
      (typeof payload === "string" && payload) ||
      `${res.status} ${res.statusText}`;
    throw new Error(message);
  }

  return payload;
}

/**
 * GET /api/audit/logs
 * Returns { logs: [...], count: number }
 */
export async function getAuditLogs({ userEmail, action, organizationId, startDate, endDate, limit = 100 } = {}) {
  const params = new URLSearchParams();
  if (userEmail)      params.set("user_email", userEmail);
  if (action)         params.set("action", action);
  if (organizationId) params.set("organization_id", organizationId);
  if (startDate)      params.set("start_date", startDate);
  if (endDate)        params.set("end_date", endDate);
  params.set("limit", String(limit));

  const res = await fetch(`/api/audit/logs?${params}`, {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });

  return parseResponse(res);
}

/**
 * GET /api/audit/actions
 * Returns { actions: string[] }
 */
export async function getAuditActions() {
  const res = await fetch("/api/audit/actions", {
    method: "GET",
    credentials: "include",
    headers: { Accept: "application/json" },
  });

  return parseResponse(res);
}
